import React from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const initials = ['SM', 'TK', 'LW'];
const gradients = [
  'linear-gradient(135deg, #6366f1, #8b5cf6)',
  'linear-gradient(135deg, #f59e0b, #eab308)',
  'linear-gradient(135deg, #3b82f6, #2563eb)',
];

const TestimonialsSection: React.FC = () => {
  const { t } = useTranslation();
  const headerRef = useScrollAnimation<HTMLDivElement>();
  const gridRef = useScrollAnimation<HTMLDivElement>(0.1);

  const items = t('testimonials.items', { returnObjects: true }) as { text: string; name: string; role: string }[];

  return (
    <section id="testimonials" className="hp-testimonials" aria-labelledby="testimonials-title">
      <div className="hp-testimonials-inner">
        <div ref={headerRef} className="hp-section-header hp-animate">
          <span className="hp-section-label">{t('testimonials.sectionLabel')}</span>
          <h2 id="testimonials-title">{t('testimonials.title')}</h2>
        </div>

        <div ref={gridRef} className="hp-testimonials-grid hp-animate hp-animate-stagger">
          {items.map((item, i) => (
            <div key={item.name} className="hp-testimonial-card hp-animate-child" style={{ transitionDelay: `${i * 0.1}s` }}>
              <div className="hp-testimonial-stars">★★★★★</div>
              <p className="hp-testimonial-text">"{item.text}"</p>
              <div className="hp-testimonial-author">
                <div className="hp-testimonial-avatar" style={{ background: gradients[i] }}>
                  {initials[i]}
                </div>
                <div>
                  <span className="hp-testimonial-name">{item.name}</span>
                  <span className="hp-testimonial-role">{item.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
